import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';

function RsSlidableNavigationPrev({ disabled, onClick }) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      buttonConfig={{
        className: 'rs-slidable-navigation__button',
        type: 'link',
        size: 'sm',
        iconOnly: true,
        ariaLabel: 'Slide previous',
        e2eName: 'slide-left',
      }}
      iconConfig={{ name: 'chevron-left', size: 'sm' }}
    />
  );
}

RsSlidableNavigationPrev.defaultProps = {
  onClick: () => {},
};

RsSlidableNavigationPrev.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default RsSlidableNavigationPrev;
